import React from 'react';
import Popper from '@mui/material/Popper';
import AlertComponent from '../Alert/Alert.component';
import { IProps } from './IProps';
import { variants } from './variants.enum';

const Component: React.FC<IProps> = ({
    lang,
    anchorEl,
    message,
    open,
    variant,
}) => {
    const _open = open && !!anchorEl;

    let popperClass = 'popper';
    switch (variant) {
        case variants.description:
            popperClass = 'popper_with-description';
            break;
        case variants.textArea:
            popperClass = 'popper_text-area';
            break;
    }

    return (
        <Popper
            className={popperClass}
            placement="bottom-start"
            open={_open}
            anchorEl={anchorEl}
            container={anchorEl ? anchorEl.parentElement : document.body}
            modifiers={[{ name: 'flip', enabled: false }]}
        >
            <AlertComponent
                severity="error"
                variant="popper"
                lang={lang}
                display={_open}
                message={message}
            />
        </Popper>
    );
};

const PopperComponent = React.memo(Component);

export default PopperComponent;
